import { Button, Form, Input, message, Modal, Select } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  validateNumberOnly,
  validateCitizenId,
} from '../../functions';
import styles from './scgFamilyConnectModal.module.scss';

const { Option } = Select;
const { confirm } = Modal;

const ScgFamilyConnectModal = () => {
  let [form] = Form.useForm();
  let [isConnected, setIsConnected] = useState(false);
  let [inputModal, setInputModal] = useState(false);

  const user = useSelector((state: any) => state.user);

  const setFormJob = (v: any) => {
    if (inputModal) {
      form.setFieldsValue({
        ...form,
        job: v,
      });
    }
  };

  const JobDropdown = () => {
    const options = [
      { value: 1, label: 'ผู้รับเหมาก่อสร้าง' },
      { value: 2, label: 'อื่นๆ' },
      { value: 3, label: 'ช่างรับเหมาทั่วไป' },
      { value: 4, label: 'สถาปนิก/นักออกแบบ' },
      { value: 5, label: 'วิศวกร' },
      { value: 6, label: 'พนักงานเอกชน' },
      { value: 7, label: 'ค้าขาย/ธุรกิจส่วนตัว' },
      { value: 8, label: 'ข้าราชการ/รัฐวิสากิจ' },
    ];

    return (
      <Select
        defaultValue={3}
        style={{ minWidth: 120 }}
        onChange={(v) => setFormJob(v)}
      >
        {options.map((option) => (
          <Option value={option.value}>{option.label}</Option>
        ))}
      </Select>
    );
  };

  const checkExistMemberScgFamily = async () => {
    const result = await axios.post(
      `/scg-family/check-existing-member`,
      {
        mobileNo: user.phone,
        citizenId: form.getFieldValue('citizenId'),
      }
    );

    return result.data;
  };

  const connectToScgFamily = async () => {
    const result = await axios.post(`/scg-family/binding`, {
      userId: user._id,
      mobileNo: user.phone,
    });

    if (!result.data.success) return false;
    return true;
  };

  const registerSCGFamily = async (
    userId: string,
    citizenId: string,
    job: string
  ) => {
    const result = await axios.post(`/scg-family/register`, {
      userId,
      citizenId,
      lkId: job,
    });

    if (!result.data.success) return false;
    return true;
  };

  const handleConnectClick = async (values: any) => {
    const existedMember = await checkExistMemberScgFamily();
    console.log(`existedMember ====> `, existedMember);
    if (existedMember && existedMember.canBinding) {
      const resultConnect = await connectToScgFamily();
      if (!resultConnect) {
        message.warning('เชื่อมต่อ scg-family ไม่สำเร็จ');
        return;
      }

      message.success('เชื่อมต่อ scg-family สำเร็จ');
      setIsConnected(true);
      setInputModal(false);
    } else if (existedMember && existedMember.canRegister) {
      confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content:
          'ท่านยังไม่ได้เป็นสมาชิก SCG Family ยืนยันการสมัครใช่หรือไม่',
        okText: 'สมัครสมาชิก',
        cancelText: 'ยกเลิก',
        async onOk() {
          const isRegisterSuccess = await registerSCGFamily(
            user._id,
            form.getFieldValue('citizenId'),
            form.getFieldValue('job')
          );
          if (isRegisterSuccess) {
            message.warning(
              'เชื่อมต่อ scg-family ไม่สำเร็จ เลขประจำตัวประชาชนไม่ถูกต้อง'
            );
          }
          Modal.destroyAll();
          setInputModal(false);
          window.location.reload();
          return;
        },
        onCancel() {},
      });
      setIsConnected(true);
      setInputModal(false);
      return;
    } else {
      message.warning(
        'เชื่อมต่อ scg-family ไม่สำเร็จ เลขประจำตัวประชาชนหรือเบอร์โทรศัพท์ไม่ถูกต้อง'
      );
    }
  };

  useEffect(() => {
    if (user.scgFamily) setIsConnected(true);
  }, [user]);

  useEffect(() => {
    setFormJob(3);
  }, []);

  return (
    <>
      {!isConnected && (
        <Button
          type="primary"
          size="large"
          onClick={() => setInputModal(true)}
          className={styles.bindBtn}
        >
          เชื่อมต่อ / สมัครสมาชิก
        </Button>
      )}
      <Modal
        title="กรุณากรอกข้อมูลเพิ่มเติมเพื่อเชื่อต่อบัญชี SCG Family"
        onCancel={() => setInputModal(false)}
        footer={false}
        visible={inputModal}
      >
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          layout="vertical"
          labelWrap
          onFinish={handleConnectClick}
        >
          <div style={{ minHeight: '172px' }}>
            <Form.Item
              label="อาชีพ"
              name="job"
              rules={[
                {
                  required: true,
                  message: 'กรุณาป้อนอาชีพ',
                },
              ]}
              style={{ textAlign: 'left' }}
            >
              <JobDropdown />
            </Form.Item>
            <Form.Item
              label="เลขประจำตัวประชาชน"
              name="citizenId"
              rules={[
                {
                  required: true,
                  validator: validateCitizenId,
                },
              ]}
              style={{ textAlign: 'left' }}
            >
              <Input
                onKeyPress={(event) => validateNumberOnly(event)}
                maxLength={13}
              />
            </Form.Item>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '1rem',
              marginTop: '48px',
            }}
          >
            <Button key="cancel" onClick={() => setInputModal(false)}>
              ยกเลิก
            </Button>
            <Button type="primary" htmlType="submit">
              เชื่อมต่อ / สมัครสมาชิก
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ScgFamilyConnectModal;
